import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'cogoport-adds-linescape-schedules',
  template: require('./cogoport-adds-linescape-schedules.component.html'),
  styles: [require('./../blog.component.scss'), require('./cogoport-adds-linescape-schedules.component.scss')]
})
export class CogoportAddsLinescapeSchedulesComponent extends BlogPage {
  title = "Cogoport adds Linescape Sailing Schedules to live Freight Rates - Linescape";
  description = "Indian digital platform integrates Linescape's schedule data with real-time freight rates for instant online bookings.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/cogoport-adds-linescape-schedules/cogoport-adds-linescape-schedules.component.ts